<script lang="ts">
	import { appStore } from '../stores/appStore';
	import { TOKENKEY } from '../utils/localStorage';
	import Preloader from '../components/auth/Preloader.svelte';
	import DarkModeToggle from '../components/auth/DarkModeToggle.svelte';
	import BrandingSide from '../components/auth/BrandingSide.svelte';
	import BackToDashboard from '../components/auth/BackToDashboard.svelte';

	function handleSignOut() {
		// Clear token from localStorage
		localStorage.removeItem(TOKENKEY);

		// Reset app store
		appStore.reset();

		// Redirect to login
		window.location.hash = '/login';
	}

	function goToHome() {
		window.location.hash = '/';
	}
</script>

<Preloader />
<DarkModeToggle />

<div class="relative z-1 bg-white p-6 sm:p-0 dark:bg-gray-900">
	<div
		class="relative flex h-screen w-full flex-col justify-center sm:p-0 lg:flex-row dark:bg-gray-900"
	>
		<!-- Left Side: Content -->
		<div class="flex w-full flex-1 flex-col lg:w-1/2">
			<div class="mx-auto w-full max-w-md pt-10">
				<!-- <BackToDashboard /> -->
			</div>

			<div class="mx-auto flex w-full max-w-md flex-1 flex-col justify-center">
				<div class="text-center mb-6">
					<svg
						class="w-16 h-16 mx-auto text-brand-500 mb-4"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
						/>
					</svg>
					<h1
						class="text-title-sm sm:text-title-md mb-2 font-semibold text-gray-800 dark:text-white/90"
					>
						Already Logged In
					</h1>
					<p class="text-sm text-gray-500 dark:text-gray-400">
						You are currently signed in to your account. Please sign out first if you want to access
						the login page.
					</p>
				</div>

				<div class="space-y-3">
					<button
						onclick={goToHome}
						class="bg-brand-500 shadow-theme-xs hover:bg-brand-600 w-full flex items-center justify-center rounded-lg px-4 py-3 text-sm font-medium text-white transition"
					>
						Go to Home
					</button>

					<button
						onclick={handleSignOut}
						class="w-full flex items-center justify-center rounded-lg px-4 py-3 text-sm font-medium border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 transition dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700"
					>
						Sign Out
					</button>
				</div>
			</div>
		</div>

		<!-- Right Side: Branding -->
		<BrandingSide />
	</div>
</div>

<style>
	:global(body) {
		margin: 0;
		padding: 0;
	}
</style>
